import { render } from "./CargoList.vue?vue&type=template&id=ddd7d280&scoped=true"
import script from "./CargoList.vue?vue&type=script&lang=js"
export * from "./CargoList.vue?vue&type=script&lang=js"

import "./CargoList.vue?vue&type=style&index=0&id=ddd7d280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd7d280"]])

export default __exports__